import React, { Component, createRef } from "react";
import { POST, loading, token, alert } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
    };
  }
    
  componentDidMount() {
    loading(false);
  }
    
  render() {
    const games = global.topup_id_pass || [];
    const filteredGames = games;
    const getGameAvailability = (item) => {
        if (item.available === false || item.active === false || item.enabled === false || item.disabled === true || item.maintenance === true || item.status === false) {
            return false;
        }
        if (typeof item.status === "string") {
            const normalizedStatus = item.status.toLowerCase();
            if (
                normalizedStatus.includes("close") ||
                normalizedStatus.includes("offline") ||
                normalizedStatus.includes("disable") ||
                normalizedStatus.includes("maintenance") ||
                normalizedStatus.includes("ไม่พร้อม")
            ) {
                return false;
            }
        }
        return true;
    };
    return (
        <div className="game-page w-100 min-vh-100 position-relative overflow-hidden">
            <div className="game-page__ambient game-page__ambient--one"></div>
            <div className="game-page__ambient game-page__ambient--two"></div>
            <div className="game-page__grid"></div>
            
            <Navbar />
            <div className="mb-5 text-white">
                <div className="container pt-5 pb-2 text-center">
                    <h2 className="fw-bold">เติมเกม ID-PASS</h2>
                    <h5 className="mb-1">
                        เติมเกม ID-PASS ตลอด 24 ชม. กับ <b>Lvup Topup</b>
                    </h5>
                </div>
            </div>
            <div className="container mx-auto my-5">
                <div className="row">
                    <div className="col-12">
                        <div className="game-panel">
                            <div className="row">
                                {filteredGames.map((item, index) => {
                                    const gameIndex = games.indexOf(item);
                                    const isAvailable = getGameAvailability(item);
                                    return (
                                        <div
                                            className={`col-6 col-sm-4 col-md-4 col-xl-3 mb-4 product ${isAvailable ? "pointer" : ""}`}
                                            key={`${item.name}-${gameIndex}`}
                                            title={item.name}
                                            onClick={() => {
                                                if (!isAvailable) {
                                                    return;
                                                }
                                                window.location.href = "/payment-game?source=topup-id-pass&id=" + gameIndex;
                                            }}
                                        >
                                            <div className={`game-card h-100 ${!isAvailable ? "game-card--disabled" : ""}`}>
                                                <div className="game-card__image-wrap">
                                                        <img
                                                        src={require(`../assets/images/game/image-${String((item.masterIndex || 0) + 2).padStart(2, "0")}.png`)}
                                                            alt={item.name}
                                                        className="w-100 hpx-120 mx-auto rounded-4 game-card__image"
                                                        style={{ objectFit: "cover" }}
                                                    />
                                                    <div className="game-card__shine"></div>
                                                </div>
                                                <div className="game-card__body">
                                                    <span className={`game-card__chip game-card__chip--${isAvailable ? "ready" : "offline"}`}>{isAvailable ? "พร้อมใช้งาน" : "ไม่พร้อมใช้งาน"}</span>
                                                    <b className="game-card__title text-center">{item.name}</b>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
  }
}
